import { useFeatureFlags } from 'hooks/useFeatureFlags'

import { Dashboardv99990101Api } from '@sequencehq/api/dashboard/v99990101'

type TriggerType = Dashboardv99990101Api.Automations.TriggerType

export const useAvailableTriggerTypes = (): TriggerType[] => {
  const flags = useFeatureFlags()

  return [
    ...(flags.showQuoteBuilder ? (['QUOTE_REQUIRES_APPROVAL'] as const) : []),
    'CONTRACT_UPLOADED',
    ...(flags.useAutomationsDunning ? (['INVOICE_SENT'] as const) : [])
  ]
}
